// Телефон клиента вводится в шторке руками. В поле стоит показ «+7 912 345-67-89», поэтому из значения
// сначала убираем наш же префикс «+7», иначе его семёрка считалась бы первой цифрой номера.
// Вставленный целиком номер с кодом страны (8912…, 7912…, +7912…) тоже принимаем.
// Возвращает до 10 цифр номера без кода страны.
export function phoneDigits(raw: string) {
  let digits = raw.replace(/^\s*\+7/, "").replace(/\D/g, "");
  if (digits.length === 11 && (digits.startsWith("7") || digits.startsWith("8"))) digits = digits.slice(1);
  return digits.slice(0, 10);
}

// Показ по мере ввода: +7 912 345-67-89.
export function formatPhoneInput(digits: string) {
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)].filter(Boolean);
  if (!parts.length) return "+7 ";
  const [code, a, b, c] = parts;
  return `+7 ${code}${a ? ` ${a}` : ""}${b ? `-${b}` : ""}${c ? `-${c}` : ""}`;
}

export const isPhoneComplete = (digits: string) => digits.length === 10;

// В запрос — 11 цифр с ведущей 7, как ждёт сервер.
export const phoneForRequest = (digits: string) => `7${digits}`;
